import { useEffect, useRef } from "react";
import { Spinner } from "../../../Layout/Common/spinner";

const legacyHandoff = () => {
  const path = window.location.pathname;

  let payload = null;
  let storageKey = null;

  if (path.startsWith("/tillpayment")) {
    const params = new URLSearchParams(window.location.search);
    payload = {
      status: params.get("status"),
      orderId: params.get("orderId"),
      transId: params.get("transId"),
    };
    storageKey = "tillPaymentResult";
  } else if (path.startsWith("/till-mywallet")) {
    const parts = path.split("/").filter(Boolean);
    payload = {
      source: "tillWallet",
      status: parts[1],
      transId: parts[2],
      isDefault: parts[3],
    };
    storageKey = "tillWalletResult";
  }

  if (!payload) return;

  const opener = window.opener;
  const parentWin = window.parent !== window ? window.parent : null;
  const target = opener || parentWin;

  if (target) {
    target.postMessage(payload, "*");
    if (opener) {
      setTimeout(() => window.close(), 500);
    }
  } else {
    localStorage.setItem(storageKey, JSON.stringify(payload));
    const back = localStorage.getItem("tillReturnUrl") || "/";
    localStorage.removeItem("tillReturnUrl");
    window.location.replace(back);
  }
};

export const TillPaymentProcessing = () => {
  const isCardVerification = window.location.pathname.toLowerCase().startsWith("/till-mywallet");
  const startedRef = useRef(false);

  useEffect(() => {
    if (startedRef.current) return;
    startedRef.current = true;
    legacyHandoff();
  }, []);

  return (
    <div
      style={{
        position: "fixed",
        inset: 0,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        gap: "16px",
        padding: "24px",
        textAlign: "center",
        background: "#fff",
        fontFamily: "Arial, Helvetica, sans-serif",
      }}
    >
      <Spinner size={56} />
      <p style={{ margin: 0, fontSize: "17px", fontWeight: 600, color: "#333" }}>
        {isCardVerification ? "Verifying your card..." : "Payment processing..."}
      </p>
      <p style={{ margin: 0, fontSize: "13px", color: "#666" }}>Please do not refresh or close this window.</p>
    </div>
  );
};
